import { ModalStore } from 'components/modal/modalStore';
import AppStore, { AccessType } from 'container/app/appStore';
import { FolderFieldID } from '../dbFolderContainer';
import { action, observable } from 'mobx';
import { SelectFolderStore } from 'fields/selectField/selectFolderStore';
import { FieldGroupModel, FieldType } from 'api/fieldModel';

export class AddFolderModalStore extends ModalStore {
  @observable updatedRootFolder;
  @observable folderAlias;
  @observable footerContent;

  // eslint-disable-next-line no-useless-constructor
  constructor(header: string, appStore: AppStore) {
    super(header, appStore);
  }

  initFields(): FieldGroupModel[] {
    const nameField = {
      id: FolderFieldID.NAME,
      name: 'Name',
      description: '',
      type: FieldType.TEXT,
      required: true,
      value: null,
    };
    const treeField = {
      id: FolderFieldID.PARENT_ID,
      name: 'Select parent folder',
      description: '',
      type: FieldType.SELECT,
      placeholder: 'Choose a folder ',
      required: true,
      value: this.appStore.selectedFolder ? { value: this.appStore.selectedFolder.id, label: this.appStore.selectedFolder.folderName } : null,
      customFieldStore: new SelectFolderStore(this.appStore, AccessType.WRITE),
    };
  

    /* Enables public folder and document feature. */
    const isPublicField = {
      id: FolderFieldID.IS_PUBLIC,
      name: 'Make folder public and allow everyone to view',
      description: 'Please ensure the parent folder is public and you have admin access',
      type: FieldType.CHECKBOX,
      required: true,
      value: false,
    };

    const folderAlias = {
      id: FolderFieldID.FOLDER_ALIAS,
      name: 'Pretty URL',
      description: 'This is the pretty url for the org',
      type: FieldType.TEXT,
      placeholder: '',
      value: this.folderAlias,
    };

    const folderDescription = {
      id: FolderFieldID.LANDING_PAGE_DESCRIPTION,
      name: 'Landing Page Description',
      description: 'This description will be displayed on the org page',
      type: FieldType.TEXTAREA,
      placeholder: 'Please type landing page description',
      value: this.footerContent,
    };

    return [{
      id: 'default_',
      name: 'default_',
      fields: [
        nameField,
        treeField,
        folderAlias,
        folderDescription,
      ],
    }] as FieldGroupModel[];
  }
}

